import Controller from '@ember/controller';
import type { ModelType } from 'codecrafters-frontend/routes/settings';

export default class ProfileController extends Controller {
  declare model: ModelType;
}
